module.exports = __webpack_public_path__ + "img/stas-main_320.4d0fda6e.webp";